const {migrateStructuredMegaMenuSubmenuDesign} = require('./design')

module.exports = {
    migrateStructuredMegaMenuSubmenuDesign
}
